import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from 'react-i18next';

import { MainPageWithButtons, TextInputComponent, CapsuleButton } from "../_components";
import { Product } from "../_models/Product";
import { ProductsActions } from "../_actions/ProductsActions";

export function CreateProductDetailsView() {

    //LIBRARIES
    const dispatch = useDispatch();
    const { t } = useTranslation();

    //LOCAL STATE
    const [name, setName] = useState("");
    const [price, setPrice] = useState("");
    const [description, setDescription] = useState("");

    //VIEW

    return (
        <MainPageWithButtons
            pageTitle={t("mod_products_title")}
            content={content()}
            buttons={createButtons()}
        />
    );

    function content() {
        return (
            <div>
                <div className="mt-2"/>
                <div className="font-weight-bold text-uppercase">
                    {t("global_name")}
                </div>
                <TextInputComponent
                    title={t("global_name")}
                    value={name}
                    onChange={setName}
                />
                <div className="mt-2"/>
                <div className="font-weight-bold text-uppercase">
                    {t("global_price")}
                </div>
                <TextInputComponent
                    title={t("global_price")}
                    value={price}
                    onChange={setPrice}
                />
                <div className="mt-2"/>
                <div className="font-weight-bold text-uppercase">
                    {t("global_description")}
                </div>
                <TextInputComponent
                    title={t("global_description")}
                    value={description}
                    onChange={setDescription}
                />
            </div>
        );
    }

    function createButtons() {
        return [
            <CapsuleButton
                onClick={handleCreateNewProduct}
                text={t("global_save")}
            />
        ];
    }

    function handleCreateNewProduct() {
        dispatch(ProductsActions.createNewProduct({name, price, description}));
        dispatch(ProductsActions.changeSecondaryView(null));
    }
}
